export const OmIntegratorConfig = /* GraphQL */ `
  query omIntegratorConfig {
    omIntegratorConfig {
      serviceConfigurations {
        name
        urlOrigin
      }
      featureAppConfigurations {
        name
        baseUrl
        client
        css
      }
    }
  }
`;
